import { motion } from "framer-motion";
import { MessageCircle, ChevronRight } from "lucide-react";
import { SITE, waLink } from "@/lib/site";

const HERO_BG = "/images/portada.png";

export default function Hero() {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative h-[100vh] min-h-[640px] w-full overflow-hidden"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-center bg-cover scale-[1.06]"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80" />
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 70% 30%, rgba(201,162,39,0.18), transparent 55%)" }} />

      <div className="relative z-10 h-full max-w-[1320px] mx-auto px-6 md:px-10 flex items-center">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.2, 0.6, 0.2, 1] }}
            className="eyebrow text-gold mb-7"
          >
            
Diseño, Fabricación e Instalación Profesional
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 26 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.1, ease: [0.2, 0.6, 0.2, 1] }}
            className="font-display font-semibold text-white leading-[1.05] text-4xl sm:text-5xl lg:text-6xl"
          >
            Persianas y Cortinas
            <br />
            <span className="text-gold italic font-light">a la medida</span> de tu hogar
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.25 }}
            className="mt-7 text-white/85 text-base md:text-lg max-w-xl font-light leading-relaxed"
          >
            Enrollables, Blackout, Sheer Elegance, Romanas, Duo y Lambrín. Diseño, fabricación e instalación profesional para hogares y oficinas.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.4 }}
            className="mt-10 flex flex-col sm:flex-row gap-3"
          >
            <a
              data-testid="hero-cta-cotizar"
              href="#contacto"
              className="btn-gold"
            >
              Cotizar Ahora <ChevronRight size={16} />
            </a>
            <a
              data-testid="hero-cta-whatsapp"
              href={waLink(`Hola ${SITE.brandShort}, me interesa cotizar.`)}
              target="_blank"
              rel="noreferrer"
              className="btn-ghost"
            >
              <MessageCircle size={16} /> WhatsApp
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 1 }}
            className="mt-12 hidden md:flex items-center gap-5 text-white/55 text-xs tracking-[0.22em] uppercase font-display"
          >
            <span className="w-10 h-px bg-white/30" />
            Solicita tu cotización sin compromiso 
          </motion.div>
        </div>
      </div>

      <a href="#beneficios" className="scroll-indicator" aria-label="Desplazarse hacia abajo" />
    </section>
  );
}
